import * as propertyTypes from "../property_types.js"

export class UiRegion extends propertyTypes.Serializable {

    private titleMetadata = new propertyTypes.TranslatableTextProperty("title", "Title");
    public title: string;

    private visibleMetadata = new propertyTypes.TextCheckboxProperty("visible", "Visible");
    public visible: string;

    private renderHeaderMetadata = new propertyTypes.CheckBoxProperty("renderHeader", "Render header", true);
    public renderHeader: boolean;

    private sizeMetadata = new propertyTypes.ObjectListPropertyExt("size", "Size")
        .addStateImplementation("default", Size);
    public size: Size[];

    private metadata: propertyTypes.BaseProperty[];

    constructor() {
        super();
        this.metadata = [this.titleMetadata, this.visibleMetadata, this.renderHeaderMetadata, this.sizeMetadata];
    }

    hasErrors(): boolean {
        const meta = this.getMetadata();

        for (let x of meta) {
            let value = this[x.ValueField];

            if (x.IsMandatory && !value) {
                return true;
            }
        }
        return false;
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.metadata;
    }
}

class Size extends propertyTypes.Serializable {
    private containerMetadata = new propertyTypes.SelectProperty("container", "Container")
        .addOption("extrasmall", "Extra small")
        .addOption("small", "Small")
        .addOption("medium", "Medium")
        .addOption("large", "Large")
        .addOption("extralarge", "Extra large");
    public container: string;

    private widthMetadata = new propertyTypes.SelectProperty("width", "Width")
        .addOption("1/12", "1/12").addOption("2/12", "2/12").addOption("3/12", "3/12")
        .addOption("4/12", "4/12").addOption("5/12", "5/12").addOption("6/12", "6/12")
        .addOption("7/12", "7/12").addOption("8/12", "8/12").addOption("9/12", "9/12")
        .addOption("10/12", "10/12").addOption("11/12", "11/12").addOption("12/12", "12/12")

    public width: string;

    axisTextMetadata: propertyTypes.BaseProperty[] = [this.containerMetadata, this.widthMetadata];

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.axisTextMetadata;
    }
}